// Цвета для точек важности
export const importancePointColorList = {
    "undefined": "#C8D7E4",
    "0": "#fff",
    "1": "#AFE669",
    "2": "#FFDC1B",
    "3": "#FF9067",
    "4": "#FA665C"
};

// Цвета для окраски региона важности
export const importanceRegionColorList = {
    "undefined": "#CAD9E5",
    "0": "#fff",
    "1": "#B9DD9B",
    "2": "#FBF0B4",
    "3": "#FFB795",
    "4": "#F7776F"
};

// Цвета для точек сантиментов.
export const sentimentPointColorList = {
    "undefined": "#C8D7E4",
    "-1": "#FA665C",
    "0": "#7B87A5",
    "1": "#63D63B"
};

// Цвета для окраски региона сантиментов.
export const sentimentRegionColorList = {
    "undefined": "#CAD9E5",
    "-1": "#FE837B",
    "0": "#ADB6CC",
    "1": "#C7EEA6"
};